"use client";
// Time left until a moment, ticking once a second. Null once it has passed.
import { useEffect, useState } from "react";
import { fmtCountdown } from "@/lib/dashboard/format";

/**
 * Starts at null and fills in after mount: the server has no idea what second it is in
 * the reader's browser, and rendering a countdown on the server would hydrate as a
 * mismatch and then be wrong anyway.
 */
export function useCountdown(target: string | null | undefined): string | null {
  const [remaining, setRemaining] = useState<string | null>(null);

  useEffect(() => {
    const end = target ? Date.parse(target) : Number.NaN;
    if (!Number.isFinite(end)) return;

    const tick = () => setRemaining(fmtCountdown(end - Date.now()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);

  return remaining;
}
